import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Feature001 from '../../../../assets/Feature001.png';
import Feature002 from '../../../../assets/Feature002.png';
import {
  BACKGROUND_BLACK,
  BACKGROUND_LIGHT_BLACK,
  ORANGE,
  WHITE,
  LIGHT_BLUE,
} from '../../../../styles/Colors';
import { HEADER_HIGHT } from '../../../../styles/LayoutSetting';
import {
  mobileDevice,
  largeDevice,
} from '../../../../constants/DeviceBreakPoints';
import {
  Mobile,
  Default,
} from '../../../../components/MediaQueryComponent';

const styles = theme => ({
  screenContainer: {
    backgroundColor: BACKGROUND_BLACK,
    padding: '10px 20px',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mobileBackground: {
    backgroundColor: BACKGROUND_LIGHT_BLACK,
  },
  wrapperContainer: {
    width: '100%',
    maxWidth: 1400,
    padding: 10,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: `calc((100vh - ${HEADER_HIGHT}px)*0.8)`,
    [theme.breakpoints.up(largeDevice)]: {
      maxHeight: 900,
      minHeight: `calc((100vh - ${HEADER_HIGHT}px)*0.8)`,
    },
    [theme.breakpoints.down(mobileDevice)]: {
      height: 'auto',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
  },
  imageContainer: {
    width: '50%',
    padding: '0 10px',
  },
  imageText: {
    fontFamily: 'Quicksand, sans-serif',
    color: LIGHT_BLUE,
    fontSize: 16,
    textAlign: 'center',
    margin: '10px 0',
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 12,
    },
  },
  imageRowContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  widthLargerPart: {
    width: '55%',
  },
  widthNormalPart: {
    width: '40%',
  },
  imageLargerStyle: {
    width: '55%',
    height: 350,
    objectFit: 'contain',
    margin: '0 10px',
    [theme.breakpoints.down(mobileDevice)]: {
      height: 180,
    },
  },
  imageStyle: {
    width: '40%',
    height: 350,
    objectFit: 'contain',
    margin: '0 10px',
    [theme.breakpoints.down(mobileDevice)]: {
      height: 180,
    },
  },
  textContainer: {
    width: '50%',
    padding: '0 10px',
  },
  titleText: {
    fontFamily: 'Poppins, sans-serif',
    color: ORANGE,
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'left',
    lineHeight: 1.2,
    padding: '8px 0',
    margin: 10,
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 18,
      textAlign: 'center',
    },
  },
  mainText: {
    fontSize: 30,
    textAlign: 'center',
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 16,
    },
  },
  descriptionContainer: {
    margin: '10px 0',
    [theme.breakpoints.down(mobileDevice)]: {
      margin: '4px 0',
    },
  },
  descriptionText: {
    fontFamily: 'Quicksand, sans-serif',
    color: WHITE,
    fontSize: 18,
    textAlign: 'center',
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 16,
    },
  },
  highlightText: {
    color: ORANGE,
  },
});

const FeatureSection = ({
  classes,
}) => {
  const ImageTitle = (
    <div className={classes.imageRowContainer}>
      <div className={`${classes.imageText} ${classes.widthLargerPart}`}>
        Sign In Sheet
      </div>
      <div className={`${classes.imageText} ${classes.widthNormalPart}`}>
        Project Contact List
      </div>
    </div>
  );
  const ImagesRow = (
    <div className={classes.imageRowContainer}>
      <img
        alt="Feature001"
        src={Feature001}
        className={classes.imageLargerStyle}
      />
      <img
        alt="Feature002"
        src={Feature002}
        className={classes.imageStyle}
      />
    </div>
  );
  const SubTitle = (
    <div className={classes.titleText}>
      Completely Automatic Project Contact List
    </div>
  );
  const DescriptionText = (
    <React.Fragment>
      <div className={classes.descriptionContainer}>
        <span className={classes.descriptionText}>
          {[
            'LinkedField’s VIRTUAL PROJECT MANAGER ensures your project stay',
            '',
          ].join(' ')}
        </span>
        <span className={`${classes.descriptionText} ${classes.highlightText}`}>
          {[
            'OSHA & COVID-19',
            '',
          ].join(' ')}
        </span>
        <span className={classes.descriptionText}>
          {[
            'compliant from the start of every day and',
            '',
          ].join(' ')}
        </span>
        <span className={`${classes.descriptionText} ${classes.highlightText}`}>
          {[
            'know exactly who is onsite and how to contact them.',
            '',
          ].join(' ')}
        </span>
      </div>
      <div className={classes.descriptionContainer}>
        <span className={classes.descriptionText}>
          {[
            'VIRTUAL PROJECT MANAGER maintains and constantly updates your project contact list',
            'with every contact you need without any extra labor -',
            '',
          ].join(' ')}
        </span>
        <span className={`${classes.descriptionText} ${classes.highlightText}`}>
          {[
            'The more subs and workers you have on site, the faster and better LinkedField works.',
          ].join(' ')}
        </span>
      </div>
    </React.Fragment>
  );
  return (
    <React.Fragment>
      <Mobile>
        <div className={`${classes.screenContainer} ${classes.mobileBackground}`}>
          <div className={classes.wrapperContainer}>
            {SubTitle}
            {ImagesRow}
            {ImageTitle}
            {DescriptionText}
          </div>
        </div>
      </Mobile>
      <Default>
        <div className={classes.screenContainer}>
          <div className={classes.wrapperContainer}>
            <div className={classes.imageContainer}>
              {ImageTitle}
              {ImagesRow}
            </div>
            <div className={classes.textContainer}>
              {SubTitle}
              {DescriptionText}
            </div>
          </div>
        </div>
      </Default>
    </React.Fragment>
  );
};

FeatureSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FeatureSection);
